module.exports = __webpack_public_path__ + "static/img/new_program_02.f503d966.jpg";